import { CloseOutlined } from '@ant-design/icons';
import { Typography } from 'antd';

import styles from './FieldValidationMessage.module.scss';

interface IProps {
  message?: string;
}
export const FieldValidationMessage = ({ message = 'Обязательное поле' }: IProps) => (
  <div className={styles['error-block']}>
    <CloseOutlined className={styles['icon-error']} />
    <Typography className={styles['error-text']}>{message}</Typography>
  </div>
);
